import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.css';
import './styles/index.css';
import './i18n/config';  // Must be imported before App
import App from './App';
import { CompanySettingsProvider } from './contexts/CompanySettingsContext';

const root = ReactDOM?.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CompanySettingsProvider>
      <App />
    </CompanySettingsProvider>
  </React.StrictMode>
);